<template> 
    <transition
            enter-active-class="transition duration-200 ease-in"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition duration-200 ease-out"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0">
        <div
            v-if="isModalVisible"
            class="fixed top-0 bottom-0 left-0 right-0 bg-black/[0.3] flex justify-center items-center z-30"
            tabindex="-1" >
        </div>
    </transition>
    <transition
      enter-active-class="transition duration-200 ease-in"
      enter-from-class="scale-0"
      enter-to-class="scale-300"
      leave-active-class="transition duration-200 ease-out"
      leave-from-class="scale-100"
      leave-to-class="scale-0"
    >
      <div 
        v-if="isModalVisible" 
        v-on-escape="close" 
        class="fixed top-5 bottom-0 left-0 right-0 flex justify-center items-center w-full z-30"
        id="exampleModalScrollable" 
        tabindex="-1" 
        aria-labelledby="exampleModalScrollableLabel"
      >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable relative pointer-events-none  p-20 w-3/5 overscroll-none">
        <div
          class="modal-content border-none shadow-lg relative flex overflow-auto max-h-[40rem] flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded outline-none">
          <!-- @click="close" -->
          <div
            class="modal-header flex flex-shrink-0 items-center justify-between h-10 bg-dark-primary text-white rounded-t">
            <h5 class="text-base font-medium leading-normal px-4" id="exampleModalScrollableLabel">
              <slot name="header">
              </slot>
            </h5>
          </div>
          <div class="modal-body h-3/4 min-h-[300px] overflow-auto relative w-full p-4 bg-gray-50">
            <slot name="body">
            </slot>
          </div>
          <!-- @click="close" -->
          <div class="modal-footer h-12 bg-gray-150 flex flex-shrink-0 flex-wrap items-center justify-center border-t-2 border-gray-200 rounded-b">
            <BaseButton type="button"
              class=""
              data-bs-dismiss="modal" @click="close">
              Close
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<script setup>
import { defineEmits, defineProps } from "vue";
import BaseButton from "./base-components/BaseButton.vue";

const props = defineProps(['isModalVisible'])


const emit = defineEmits(['close'])


function close () {
    emit('close')
}
</script>
